import React from 'react'
import { Link } from 'react-router-dom'
import Header from'../Component/Header';
import Footer from'../Component/Footer';  
import { getPrincipalMessage } from "../Service/Api"; 
import LazyLoad from 'react-lazyload';
import { useState ,useEffect } from 'react';
const ManagerMessage = () => {
  useEffect(() => {
    document.title = 'Manager Message-  St. Francis Xavier School';  
}, []); 
    const [data, setData] = useState([]);
    useEffect(() => {
     const fetchData = async () => {
       try {
         const msgdata = await getPrincipalMessage();
        const data = msgdata.filter((item) => item.category === "Manager");
        
         setData(data);
       } catch (error) {
         console.error("Error fetching online registration data:", error);
       }  
     };
     fetchData();
   }, []);
    return (
        <>
        <Header/>
        <div className="innerslide">
              <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li>   
                <li>  Message</li>
                <li>Manager's Message</li>
              </ul>
          </div>
            <section className="innerbody">
               <div className='container'>
                <div className='row'>
                {data.length > 0 && (
                    <div className="clearfix">
                       <LazyLoad> <img 
                        src={`https://webapi.entab.info/api/image/${data[0].attachments}`} 
                        className="img-fluid col-sm-12 col-md-4 float-md-end mb-3 msgimg" 
                        alt={data[0].name || 'Image'}
                      /></LazyLoad>
                      <p><div dangerouslySetInnerHTML={{ __html: data[0].message }} /></p> 
                      <p className="name">
                        {data[0].name}<span> {data[0].category} </span>
                      </p>
                    </div>
                  )}

                  {data.length === 0  && (
                    <div className="clearfix">
                       <LazyLoad> <img 
                        src="https://webapi.entab.info/api/image/SFXH/public/images/default.png" 
                        className="img-fluid col-sm-12 col-md-4 float-md-end mb-3 msgimg" 
                        alt=""
                      /></LazyLoad>
                      <p>It is my privilege to write a short message for the Website of St. Francis Xavier School. We live in a
                      world of amazingly fast, instant and high-speed exchange of information and knowledge. And also we can
                      make use of the technological advantages for the development of our school, staff and students. For
                      students of St. Xavier’s` too, past and present as well as the many well wishers of this great and noble
                      institution, the quick and immediate access to the school website can bring their beloved St. Xavier`s
                      closer to their hearts wherever they might be in this beautiful world.</p>
                  <p>I take this occasion to congratulate the principal, staff, students and parents for their strong sense of
                      commitment, service and responsibility that has transformed this institution into an outstanding and
                      significant temple of learning today. St. Xavier’s has tried its best to excel in all departments of its
                      students` growth. The specialty of this institute is that it has made quality education accessible to
                      all, thanks to the highly motivated staff and the availability of quality infrastructure.</p>
                  <p>I pray that the Almighty God continues to bless this school as well as all the members of the Xavierite
                      family, including the students, parents, and all those associated with this institution.</p>
                      <p className="name"> Fr. Pedro Joao Rodrigues
                         <span>  Manager </span>
                      </p>
                    </div>
                  )}
                </div> 
                </div> 
             </section>
            <Footer/>
        </>
    )
}

export default ManagerMessage